import { useContext } from "react"
import { useLocale } from "react-polyglot-hooks"
import styled, { css } from "styled-components"
import dynamic from "next/dynamic"
import { CarContext } from "scenes/CarScene/CarContext"
import { mq } from "helpers/styled"

const PreOwned = dynamic(() => import("./PreOwned"))
const Special = dynamic(() => import("./Special"))
const Promotion = dynamic(() => import("./Promotion"))
const TestDrive = dynamic(() => import("./TestDrive"))
const CustomCardOne = dynamic(() => import("./CustomCardOne"))
const CustomCardTwo = dynamic(() => import("./CustomCardTwo"))
const OnlineScoring = dynamic(() => import("./OnlineScoring"))

const Wrapper = styled.div`
  display: grid;
  gap: 15px;

  /*
    All promo cards have the same height (based on auto) by using 1fr for row
    sizes. If the PreOwned banner exists it will force the other promos to 120px
    which is way too big so we set the first element to auto and the rest to 1fr.
  */
  grid-auto-rows: 1fr;
  ${({ hasPreOwned }) =>
    hasPreOwned &&
    css`
      grid-template-rows: auto;
    `}

  @media ${mq("sm")} {
    grid-template-columns: repeat(2, 1fr);
    gap: 25px 18px;
  }

  @media ${mq("lg")} {
    gap: 25px 30px;
  }
`

export default function Promotions() {
  const { car } = useContext(CarContext)
  const locale = useLocale()
  const { specialPromotion, promotion, testDrive, onlineScoring, sellingStatus, customCardOne, customCardTwo } = car
  const showPreOwned = locale === "es" && sellingStatus === "pre-owned"

  return (
    <Wrapper hasPreOwned={showPreOwned}>
      {showPreOwned && <PreOwned />}
      {specialPromotion && <Special title={car.specialPromotionTitle} description={car.specialPromotionDescription} />}
      {promotion && <Promotion title={car.promotionTitle} description={car.promotionDescription} />}
      {testDrive && <TestDrive title={car.testDriveTitle} description={car.testDriveDescription} />}
      {customCardOne && <CustomCardOne title={car.customCardOneTitle} description={car.customCardOneDescription} />}
      {customCardTwo && <CustomCardTwo title={car.customCardTwoTitle} description={car.customCardTwoDescription} />}
      {onlineScoring && <OnlineScoring />}
    </Wrapper>
  )
}
